import type { AfterViewInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, ContentChild, ContentChildren, DestroyRef, ElementRef, EventEmitter, HostBinding, inject, Input, Output, QueryList, Renderer2, ViewChild } from '@angular/core';
import { PageSidebarComponent } from '@shared/common/layout/index-page-layout/page-sidebar/page-sidebar.component';
import { PageSideNavComponent } from '@shared/common/layout/index-page-layout/page-sidenav/page-side-nav.component';
import { PageHeaderComponent } from '@shared/common/layout/page-header/page-header.component';

@Component({
    selector: 'app-sidebar-page-layout',
    templateUrl: './sidebar-page-layout.component.html',
    styleUrls: ['./sidebar-page-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarPageLayoutComponent implements AfterViewInit {
    private readonly _destroyRef = inject(DestroyRef);
    private readonly _renderer = inject(Renderer2);
    private readonly _elementRef = inject(ElementRef);

    @ViewChild('container') containerRef: ElementRef;
    @ContentChild(PageHeaderComponent) headerContent!: PageHeaderComponent;
    @ContentChild(PageSidebarComponent) sidebarContent!: PageSidebarComponent;

    @HostBinding('class.has-side-nav')
    @ContentChild(PageSideNavComponent)
    sideNav!: PageSideNavComponent;

    @ViewChild('pageLayoutBottom') pageLayoutBottom!: ElementRef<HTMLDivElement>;

    @HostBinding('class.hide-sidebar')
    @Input()
    hideSidebar = false;

    @ContentChildren('bottom') bottomContent!: QueryList<ElementRef>;

    @Output() contentScroll = new EventEmitter<Event>();

    public toggleSidebar(): void {
        this.hideSidebar = !this.hideSidebar;
    }

    ngAfterViewInit(): void {
        this._detectPaginator();
    }

    protected onBottomContentChanged($event: MutationRecord[]): void {
        this._detectPaginator();
    }

    private _detectPaginator(): void {
        const hasPaginator = this.pageLayoutBottom.nativeElement?.hasChildNodes();

        if (hasPaginator) {
            this._renderer.addClass(this._elementRef.nativeElement, 'has-paginator');
        } else {
            this._renderer.removeClass(this._elementRef.nativeElement, 'has-paginator');
        }
    }
}
